import { Plus, Trash2 } from 'lucide-react';
import { UseFormReturn } from 'react-hook-form';
import { ProductFormValues } from '../types';

interface ProductVariantEditorProps {
    form: UseFormReturn<ProductFormValues>;
    fields: any[];
    onRemove: (index: number) => void;
    onAppend: (variant: any) => void;
}

export function ProductVariantEditor({
    form,
    fields,
    onRemove,
    onAppend,
}: ProductVariantEditorProps) {
    const { register, watch } = form;
    const currentImages = watch('images') || [];

    return (
        <div>
            <div className="flex items-center justify-between mb-4">
                <label className="block text-sm font-medium text-gray-700 dark:text-gray-300">
                    ตัวเลือกสินค้า (เช่น สี, ไซส์)
                </label>
                <button
                    type="button"
                    onClick={() => onAppend({ name: '', sku: '', priceAdjustment: 0, variantData: {} })}
                    className="flex items-center gap-1 text-sm text-yellow-600 hover:text-yellow-700"
                >
                    <Plus className="w-4 h-4" />
                    เพิ่มตัวเลือก
                </button>
            </div>

            <div className="space-y-3">
                {fields.map((field, index) => {
                    const selectedImageIndex = watch(`variants.${index}.imageIndex`);

                    return (
                        <div key={field.id} className="flex gap-3 items-start">
                            <div className="w-24 relative">
                                <select
                                    {...register(`variants.${index}.imageIndex` as const, {
                                        setValueAs: (v) => v === '' || v === undefined ? undefined : Number(v)
                                    })}
                                    className="w-full h-10 px-2 py-1 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-yellow-500 dark:bg-gray-700 dark:text-white text-xs appearance-none cursor-pointer"
                                    title="เลือกรูปที่จะแสดงเมื่อเลือกตัวเลือกนี้"
                                >
                                    <option value="">ไม่เลือก</option>
                                    {currentImages.map((_img, imgIndex) => (
                                        <option key={imgIndex} value={imgIndex}>
                                            รูป {imgIndex + 1}
                                        </option>
                                    ))}
                                </select>
                                {typeof selectedImageIndex === 'number' && selectedImageIndex >= 0 && currentImages[selectedImageIndex] && (
                                    <div className="absolute -top-2 -right-2 w-12 h-12 rounded-full overflow-hidden border-2 border-yellow-500 bg-white shadow-md">
                                        <img
                                            src={currentImages[selectedImageIndex]?.preview}
                                            alt={`รูป ${selectedImageIndex + 1}`}
                                            className="w-full h-full object-cover"
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="flex-1">
                                <input
                                    type="text"
                                    {...register(`variants.${index}.name` as const)}
                                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-yellow-500 dark:bg-gray-700 dark:text-white text-sm"
                                    placeholder="ชื่อตัวเลือก (เช่น สีแดง, ไซส์ M)"
                                />
                            </div>
                            <div className="w-28">
                                <input
                                    type="number"
                                    step="0.01"
                                    {...register(`variants.${index}.priceAdjustment` as const)}
                                    className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-yellow-500 dark:bg-gray-700 dark:text-white text-sm"
                                    placeholder="+/- ฿"
                                />
                            </div>
                            <button
                                type="button"
                                onClick={() => onRemove(index)}
                                className="p-2 text-red-600 hover:text-red-700"
                            >
                                <Trash2 className="w-4 h-4" />
                            </button>
                        </div>
                    );
                })}
            </div>
            {currentImages.length > 0 && fields.length > 0 && (
                <p className="text-xs text-gray-500 dark:text-gray-400 mt-2">
                    เลือกรูปที่จะแสดงเมื่อลูกค้าเลือกตัวเลือกนั้นๆ ในแอปมือถือ (auto-scroll)
                </p>
            )}
        </div>
    );
}
